import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { plainToClass } from 'class-transformer';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { trackingObject } from '../rastreo/rastreo.component';
import { environment } from './../../../../environments/environment';
import { Mensaje } from './../../../shared/models/mensaje';
import { Producto } from './../../../shared/models/producto';
import { HttpRequestService } from './../../../shared/servicios/HttpRequestService';

@Injectable({
  providedIn: 'root',
})
export class PedidosService {
  constructor(
    private http: HttpClient,
    private httpRequestService: HttpRequestService
  ) { }

  private readonly triidyServiceUrl = `${environment.apiTriidyUrl}`;
  private readonly pedidosEnviaUrl = `${environment.apiEnviaUrl}`;
  private readonly apiSalesUrl = `${environment.apiTriidyUrlVentas}`;

  trackingGuide(object: trackingObject): Observable<any> {
    const dataUpdate = {
      ...object,
    };

    return this.http.post<any>(this.apiSalesUrl + '/api/Tracking', dataUpdate).pipe(
      map(
        (resp) => {
          return resp;
        },
        (err: any) => {
          console.warn(err);
        }
      )
    );
  }

  getProductoByGuia(guia: string): Observable<Producto[]> {
    const token = environment.serviceToken;
    const params = this.httpRequestService.getHttpParamsRequestParams({
      guia,
      token,
    });
    return this.http
      .get<Producto[]>(`${this.triidyServiceUrl}/tracking`, {
        params,
      })
      .pipe(
        map((respuesta) => {
          return plainToClass(Producto, respuesta);
        })
      );
  }

  getProductoEnviaByGuia(guia: string): Observable<Producto> {
    return this.http
      .get<any>(`${this.pedidosEnviaUrl}/ConsultaGuia/${guia}`)
      .pipe(
        map((respuesta) => {
          const productoEnvia: Producto = {};
          productoEnvia.ciudad_remitente = respuesta.ciudad_origen;
          productoEnvia.nombre_destinatario = respuesta.nombre_destinatario;
          productoEnvia.ciudad_destinatario = respuesta.ciudad_destino;
          productoEnvia.direccion_destinatario =
            respuesta.direccion_destinatario;
          productoEnvia.estado_transportadora = respuesta.estado;
          productoEnvia.estado_transportadora = respuesta.estado;
          productoEnvia.detalle_pedido = respuesta.contenido;
          productoEnvia.guia = respuesta.guia;
          productoEnvia.fecha_pedido = respuesta.fecha_entrega;
          productoEnvia.nombre_remitente = respuesta.nombre_remitente;
          return plainToClass(Producto, productoEnvia);
        })
      );
  }

  getProductoByGuiaServientrega(guia: string): Observable<Producto> {
    const token = environment.serviceToken;
    const params = this.httpRequestService.getHttpParamsRequestParams({
      guia,
      token,
    });
    return this.http
      .get<any>(`${this.triidyServiceUrl}/tracking_servientrega`, {
        params,
      })
      .pipe(
        map((respuesta) => {
          return plainToClass(Producto, respuesta);
        })
      );
  }

  getMensajes(usuario: string): Observable<Mensaje[]> {
    const token = environment.serviceToken;
    const usr = usuario;
    const params = this.httpRequestService.getHttpParamsRequestParams({
      usr,
      token,
    });
    return this.http
      .get<Mensaje[]>(`${this.triidyServiceUrl}/GetNotification`, {
        params,
      })
      .pipe(
        map((respuestaMensajes) => {
          return plainToClass(Mensaje, respuestaMensajes);
        })
      );
  }

  verificaLog(ide: string): Observable<any> {

    const id = ide;
    const token = environment.serviceToken;
    const params = this.httpRequestService.getHttpParamsRequestParams({
      id,
      token
    });
    return this.http
      .get<any>(`${this.triidyServiceUrl}/LogTracking`, {
        params,
      })
      .pipe(
        map((resp) => {
          return resp;
        })
      );
  }
}
